<script setup lang="ts">
import IconItem from '@/components/Icon/IconItem.vue'
import TypographyWithPrefix from '@/components/Typography/TypographyWithPrefix.vue'

type Props = {
    lowSignal?: boolean
}
defineProps<Props>()
</script>

<template>
    <TypographyWithPrefix v-if="lowSignal" :label="$t('device.status.lowSignal')">
        <IconItem icon="triangle-exclamation" class="warning" />
    </TypographyWithPrefix>
</template>

<style lang="scss">
.warning {
    & span {
        font-size: small;
    }
    & svg {
        color: $primary;
        width: 15px;
    }
}
</style>
